import { vsingleton } from '@niknevis/vue-modules'
import RouteBase from '@niknevis/vue-modules/abstracts/RouteBase'

const ROUTE_PREFIX: string = 'admin.support.tickets.'

@vsingleton()
export class AdminTicketAnswerRoute extends RouteBase {
  prefix = ROUTE_PREFIX + 'answers.'

  store(id) {
    return this.ziggyRoute('store', id)
  }

  update(ticketId, id) {
    return this.ziggyRoute('update', { ticket: ticketId, answer: id, '_method': 'put' })
  }

  destroy(ticketId, id) {
    return this.ziggyRoute('destroy', { ticket: ticketId, answer: id })
  }

}